import { Button, Typography } from 'antd';
import { formatMetric, type DataValue } from './lib';

const { Text } = Typography;

export function DetailMetric({ data, canOpen, onClick }: {
  data?: DataValue<number> | null;
  canOpen: boolean;
  onClick: () => void;
}) {
  const value = formatMetric(data);
  return canOpen && data?.value != null
    ? <Button type="link" onClick={onClick}>{value}</Button>
    : <Text>{value}</Text>;
}
